import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./hero/SectionHero.css";
import Slide1 from "./hero/Slide1";
import Slide2 from "./hero/Slide2";
import Slide3 from "./hero/Slide3";

const SectionHero = () => {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        swipe: true,
        beforeChange: (current, next) => {
            const videos = document.querySelectorAll("video");
            videos.forEach(video => {
                video.currentTime = 0;
                video.pause();
            });
        },
        afterChange: (current) => {
            const activeSlide = document.querySelector(`.slick-slide[data-index="${current}"]`);
            const video = activeSlide.querySelector("video");
            if (video) {
                video.play();
            }
        }
    };

    return (
        <section id="hero">
            <Slider ref={sliderRef} {...settings}>
                <Slide1 sliderRef={sliderRef} />
                <Slide2 sliderRef={sliderRef} />
                <Slide3 />
            </Slider>
        </section>
    );
}

export default SectionHero;